const pageNumberController = (props: {
  isPaginationAvailable?: boolean;
  limit: number;
  total: number;
  currentPage: number;
}) => {
  const { limit, total, isPaginationAvailable, currentPage } = props;

  if (!isPaginationAvailable) {
    return {
      totalPagesNumber: null,
      currentPageNumber: 1,
      nextPageNumber: 2,
      prevPageNumber: null,
    };
  }

  const totalPagesNumber = Math.ceil(total / limit);
  let nextPageNumber: number | null = currentPage + 1;
  let prevPageNumber: number | null = currentPage - 1;

  if (nextPageNumber > totalPagesNumber) nextPageNumber = null;
  if (prevPageNumber < 0) prevPageNumber = null;

  return {
    totalPagesNumber,
    currentPageNumber: currentPage,
    nextPageNumber,
    prevPageNumber,
  };
};

export default pageNumberController;
